<div class="hot-table sku-config-table hot-custom-check-box bulk-hot-table">
  <hot-table [hotId]="hotTableId" [settings]="hotTableSettings"></hot-table>
</div>

